import React, { useState, useEffect } from "react";
import axios from "axios";
import {Link, useNavigate} from 'react-router-dom'
import { useAuth } from '../AuthContext';
import UserStatus from './UserStatus';
import { useLocation } from 'react-router-dom';
import API from '../api';


function Activate() {
    
const [message, setMessage] = useState('');
const [user, setUser] = useState(null);
const { login } = useAuth();
const [values, setValues] = useState({ email: '', otp: '' });
const navigate = useNavigate();
const location = useLocation(); // ✅ this gets the passed state

useEffect(() => {
  document.title = "Activate | TradeBarta.com";
}, []);


useEffect(() => {
  if (location.state?.email) {
    setValues((prev) => ({ ...prev, email: location.state.email }));
  }
}, [location]);

      function handleSubmit(e)
      {
              e.preventDefault()
                  API.post('/verify_otp', values)
                  .then((res) => {
                  console.log(res);
                  setMessage(res.data.message);
                  //setUser(res.data.user);
                  // login(res.data.user);
                  // navigate('/Dashboard'); // Redirect after successful login
})
.catch((err) => {
  console.error(err);
  setMessage(err.response?.data?.message || 'OTP verification failed'); // ✅ show error message
  setUser(null);
});
 
            }

  return (
      <div>
      <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "150" height = "45" src={require("../images/logo.png")} alt="Logo" />
            </a>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/how">How It Works</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/create">About Us</a>
                </li>

              </ul>
            </div>
        
          </nav>
        </div>
      </div>
    </div>
  </section>

  <section id="hero-area" className="header-area header-ten">
    <div className="header-inner">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 co-12">
            <div className="home-slider">
              <div className="form-container">

    <h1>Confirm OTP</h1>

                 <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor='text'>Enter OTP sent to your email</label>
                        <input type='text' name='otp' required onChange={(e)=> setValues({...values, otp: e.target.value})} />
                    </div>
                   <div>
                        <button type='submit'>Submit</button>
                    </div>
                    {message && (
  <p style={{ color: message.includes('successfully') ? 'green' : 'red' }}>
    {message}
  </p>
)}
                </form>

              </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </section>

<section className="footer-area footer-five">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-5">
          <div className="footer-top-content">
            <div className="footer-logo text-center">
              <a href="/">
                <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
              </a>
            </div>
         <div className="text-center">
            <p className="text">Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum
              has been. </p>           
         </div>
          </div>
        </div>
      </div>
      
    </div>
    
    <div className="footer-copyright">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="copyright text-center">
              <p className="text">Copyright © 2024 Ayro UI. All Rights Reserved</p>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </section>

           
</div>
  
      )
}

export default Activate;
